import { __awaiter } from "tslib";
import * as React from 'react';
import { useCallback, useMemo } from 'react';
import { eachDayOfInterval } from 'date-fns';
import { API_DATE_FORMAT, format } from '../../../../../utils';
import { sortSegments } from '../utils';
import { useWeekCalendarMinPrices } from '@shared/lib/results';
import WeekCalendarBase from '../../../../../WeekCalendar';
const WeekCalendar = ({ searchParameters, legId, startNewSearch, hidePrice, alternativePrices, minDate, allowSelectWithoutPrice, avaliableDateRange, currentMinPriceSelectedDate, isRT }) => {
    const { calendarPage, calendarParams, loading, getPrices, nextCalendarPage, prevCalendarPage } = useWeekCalendarMinPrices({ legId, searchParameters });
    const { centralDate, startDate, endDate } = calendarParams;
    const calendarPrices = useMemo(() => {
        var _a;
        const showAlternativePrices = legId === 0 && calendarPage === 0 && alternativePrices;
        const prices = showAlternativePrices ? alternativePrices : (_a = getPrices(legId, isRT)) !== null && _a !== void 0 ? _a : alternativePrices;
        const dateWithPriceMap = new Map(prices.map(dateWithPrice => [dateWithPrice.date, dateWithPrice]));
        const daysIntervalDates = eachDayOfInterval({ start: startDate, end: endDate });
        return daysIntervalDates.map(date => {
            var _a;
            const formatDate = format(date, API_DATE_FORMAT);
            const dateWithPrice = dateWithPriceMap.get(formatDate);
            return {
                date: format(date, API_DATE_FORMAT),
                price: (_a = dateWithPrice === null || dateWithPrice === void 0 ? void 0 : dateWithPrice.price) !== null && _a !== void 0 ? _a : null
            };
        });
    }, [alternativePrices, legId, isRT, calendarPage, startDate, endDate, getPrices]);
    const loadNewDates = useCallback((type) => __awaiter(void 0, void 0, void 0, function* () {
        if (type === 'increase') {
            nextCalendarPage();
        }
        else {
            prevCalendarPage();
        }
    }), [nextCalendarPage, prevCalendarPage]);
    const onDateClick = useCallback((date) => {
        const segments = [...searchParameters.segments];
        segments[legId] = Object.assign(Object.assign({}, segments[legId]), { date: format(date, API_DATE_FORMAT) });
        startNewSearch(Object.assign(Object.assign({}, searchParameters), { segments: sortSegments(legId, date, segments) }));
    }, [searchParameters, legId]);
    return (React.createElement(WeekCalendarBase, { loading: loading, prices: calendarPrices, centralDate: centralDate, onSelect: onDateClick, onRangeChange: loadNewDates, hidePrice: hidePrice, isMilesSearch: searchParameters === null || searchParameters === void 0 ? void 0 : searchParameters.ffpMode, minDate: minDate, allowSelectWithoutPrice: allowSelectWithoutPrice, avaliableDateRange: avaliableDateRange, currentMinPriceSelectedDate: currentMinPriceSelectedDate }));
};
export default WeekCalendar;
